<template>
  <div class="news-detail">
    <div class="content">
      <a-breadcrumb>
        <span slot="separator">
          <img src="~@/assets/img/detail-arrow.svg" style="margin: 0 6px" />
        </span>
        <a-breadcrumb-item href="">
          <img src="~@/assets/img/home.png" class="home-class" />
          <span style="color: #333">首页</span>
        </a-breadcrumb-item>
        <a-breadcrumb-item href="">
          <span style="color: #333">新闻资讯</span>
        </a-breadcrumb-item>
        <a-breadcrumb-item>
          <span style="color: #7f7f7f">{{ newsDetailObj.title }}</span>
        </a-breadcrumb-item>
      </a-breadcrumb>
      <div class="box">
        <article :class="{ articlew100: !showInfoList }" style="overflow: hidden">
          <h5>{{ newsDetailObj.title }}</h5>
          <span>{{ newsDetailObj.releaseDate }}</span>

          <div v-html="newsDetailObj.content"></div>
          <!-- <img src="~@/assets/img/article-img.png" alt="" />
          <p>
            日前，经中央批准，全国评比达标表彰工作协调小组印发《社会组织评比达标表彰活动管理办法》（国评组发〔2022〕3号，以下简称《办法》）。《办法》对社会组织开展评比达标表彰活动的适用范围、申报条件、审批机制、程序要求、禁止情形、监管体制、违规处置、荣誉撤销等作出全面规定，为加强社会组织评比达标表彰活动管理、规范社会组织评比达标表彰活动开展提供了制度遵循。
            全文公布如下
          </p>
          <p>社会组织评比达标表彰活动管理办法</p>
          <p>
            第一条为规范社会组织开展评比达标表彰活动，加强社会组织评比达标表彰活动管理，根据《国家功勋荣誉表彰条例》和《评比达标表彰活动管理办法》等，制定本办法。
          </p>
          <p>
            第二条
            本办法适用于在社会组织登记管理机关依法登记的社会团体、基金会、民办非企业单位（社会服务机构）主办的评比达标表彰活动。
          </p>
          <p>第三条 社会组织开展的下列活动不适用本办法</p> -->
          <div class="footer-time">
            <em>来源：{{ newsDetailObj.source }}</em>
            <em>{{ newsDetailObj.releaseDate }}</em>
          </div>
        </article>
        <div class="info-list" v-if="showInfoList">
          <div
            class="list"
            v-if="typeList.hot"
            @click="artNewsDetailFunc(typeList.hot.id)"
          >
            <h4>热门资讯</h4>
            <img :src="typeList.hot.image" alt="" />
            <p>{{ typeList.hot.title }}</p>
          </div>
          <div
            class="list"
            v-if="typeList.news"
            @click="artNewsDetailFunc(typeList.news.id)"
          >
            <h4>最新资讯</h4>
            <img :src="typeList.news.image" alt="" />
            <p>{{ typeList.news.title }}</p>
          </div>
          <div
            class="list"
            v-if="typeList.related"
            @click="artNewsDetailFunc(typeList.related.id)"
          >
            <h4>相关资讯</h4>
            <img :src="typeList.related.image" alt="" />
            <p>{{ typeList.related.title }}</p>
          </div>
        </div>
      </div>
      <section>
        <div v-if="showInfoList">
          <h5>推荐</h5>
          <ul class="recommend-list">
            <li
              v-for="item in recommendList"
              :key="item.id"
              @click="artNewsDetailFunc(item.id)"
            >
              <span>{{ item.title }}</span>
              <em>[{{ item.releaseDate && item.releaseDate.substring(0, 10) }}]</em>
            </li>
          </ul>
        </div>
        <!-- <textarea class="msg-box" placeholder="说点什么..."></textarea>
        <div class="comment-box">
          <span>添加表情</span>
          <div class="btn">评论</div>
        </div> -->
      </section>
    </div>
  </div>
</template>
<script>
import { artNewsDetail, artNewsRecommendList, artNewsTypeList } from "@/api/NewInfo";
export default {
  name: "NewsDetail",
  data() {
    return {
      query: {},
      showInfoList: true,
      newsDetailObj: {},
      typeList: [],
      recommendList: [],
    };
  },
  mounted() {
    this.query = this.$route.query;
    if (+this.query.currentActiveKey === 1) {
      this.artNewsRecommendListFunc(1);
      this.artNewsTypeListFunc(1);
    } else if (+this.query.currentActiveKey === 2) {
      this.showInfoList = false;
    }
    this.artNewsDetailFunc(this.query.id);
  },
  methods: {
    artNewsDetailFunc(id) {
      artNewsDetail(id)
        .then((res) => {
          this.newsDetailObj = res.data;
          this.$nextTick(() => {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    artNewsRecommendListFunc(classify) {
      let params = {
        limit: 6,
        classify,
        id: this.query.id,
      };
      artNewsRecommendList(params)
        .then((res) => {
          this.recommendList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    artNewsTypeListFunc(classify) {
      let params = {
        classify,
        id: this.query.id,
      };
      artNewsTypeList(params)
        .then((res) => {
          this.typeList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="scss">
.news-detail {
  border-top: 1px solid #f2f2f2;
  .content {
    margin: 0 auto;
    width: 1240px;
    .ant-breadcrumb {
      line-height: 14px;
      margin: 17px 0 58px;
    }
    .home-class {
      width: 14px;
      height: 14px;
      vertical-align: top;
      margin-right: 2px;
    }
    .box {
      display: flex;
      justify-content: space-between;
      article {
        width: 924px;
        h5 {
          margin: 0;
          line-height: 72px;
          text-align: center;
          font-size: 26px;
          color: #333;
        }
        span {
          display: block;
          line-height: 15px;
          margin-bottom: 82px;
          text-align: center;
          font-size: 13px;
          color: #333;
        }
        img {
          width: 100%;
          margin-bottom: 23px;
        }
        p {
          margin-bottom: 26px;
          line-height: 24px;
          font-size: 15px;
          color: #333;
        }
        p:nth-of-type(1) {
          text-indent: 2em;
        }

        p:nth-last-of-type(1) {
          margin-bottom: 16px;
        }
        .footer-time {
          border-top: 1px solid #f2f2f2;
          margin-bottom: 31px;
          line-height: 55px;
          font-size: 13px;
          color: #7f7f7f;
          em {
            margin-right: 24px;
          }
        }
      }
      .info-list {
        width: 276px;
        .list {
          margin-bottom: 67px;
        }
        h4 {
          margin: 19px 0;
          line-height: 23px;
          border-left: 4px solid #2d3f51;
          text-indent: 16px;
        }
        img {
          width: 276px;
          height: 131px;
          margin-bottom: 6px;
        }
        p {
          margin: 0;
          line-height: 21px;
          font-size: 15px;
          color: #333;
        }
      }
    }
    section {
      h5 {
        margin-bottom: 18px;
        line-height: 24px;
        border-left: 4px solid #2d3f51;
        text-indent: 14px;
      }
      .recommend-list {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin-bottom: 27px;
        li {
          width: 550px;
          line-height: 45px;
          margin-bottom: 33px;
          display: flex;
          justify-content: space-between;
          border-bottom: 1px solid #dbdbdb;
        }
      }
      .msg-box {
        width: 100%;
        height: 96px;
        resize: none;
        padding: 22px 24px;
        border: 1px solid #f3f3f3;
      }
      .comment-box {
        padding-top: 14px;
        display: flex;
        justify-content: space-between;
        span {
          height: 23px;
          font-size: 16px;
          color: #7f7f7f;
          position: relative;
          text-indent: 26px;
          &::before {
            content: "";
            width: 21px;
            height: 21px;
            background: url("~@/assets/img/msg-icon.png") no-repeat;
            background-size: 21px 21px;
            position: absolute;
            left: 1px;
            top: 1px;
          }
        }
        .btn {
          width: 135px;
          height: 45px;
          line-height: 45px;
          font-size: 15px;
          color: #fff;
          text-align: center;
          background-color: #2d3f51;
        }
      }
    }
  }
}
input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  font-size: 15px;
  color: #d7d7d7;
}
.articlew100 {
  width: 100% !important;
}
</style>
